<template>
  <div>
    <OnboardingTextSection>
      <b>Проект</b> — это контейнер для хранения и управления<br>
      рекламными кампаниями. Вы можете объединить в<br>
      нем кампании <b>из разных рекламных площадок</b>,<br>
      чтобы управлять ими и выгружать сводную<br> статистику.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Проекты можно создавать <b>только внутри<br> Стандартного аккаунта</b>.
    </OnboardingTextSection>

    <OnboardingImageSection
      :image="marySpeaking"
      width="135px"
      align="center"
    />
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';
  import OnboardingImageSection from 'onboarding/onboardings/components/OnboardingImageSection';

  import marySpeaking from 'assets/mascot/mary-speaking.png';

  export default {
    name: 'WhatIsProjectStep',
    components: {OnboardingTextSection, OnboardingImageSection},
    data () {
      return {
        marySpeaking
      };
    }
  };
</script>
